/**
 * Thickness of the tab rail and of the active tab's underline. The two must stay
 * equal: the active item is pulled down by this amount so its underline sits
 * exactly on top of the rail rather than beside it.
 */
export const TAB_BORDER_WIDTH = 3;

/** Rail colour behind the tabs. */
export const TAB_RAIL_COLOR = '#E5E5E5';
